import {IMessageData, MESSAGE_ANIMATION_TYPE, MESSAGE_DISPLAY_MODE, PLATFORM_MESSAGE_TYPE} from "../firebase_const";

export enum MESSAGE_TYPE {
    ADDED= "added",
    REMOVED="removed",
}

export type OpenWithinGameType = '0' | '1';

export interface IOMGParsedData{
    MessageDataJson: string;
    Messages: string;
    OmgType: string;
    OpenedWithinGame: OpenWithinGameType;
}

export interface IReceivedMessage<TMessage extends IMessageData = IMessageData> {
    data: TMessage;
    id: string;
    type: MESSAGE_TYPE;
}

export interface IMessageDataJson {
    DisplayMode: MESSAGE_DISPLAY_MODE;
    AnimationType: MESSAGE_ANIMATION_TYPE;
}

export enum GamblingSessionActionType {
    LossLimitReached = 0,
    TimeLimitReached = 1,
    TimeReminder = 2,
    AdvancedWarningNetLossLimit = 3,
    AdvancedWarningTimeLimit = 4
}

export interface IGamblingSessionActionEvent {
    PlatformMessagesType: PLATFORM_MESSAGE_TYPE;
    MessageDataJson: string;

}

export interface IGamblingSessionActionDataReceivedFromPlatform {
    MessageType: GamblingSessionActionType;
    SessionTotalWins: number;
    SessionTotalBets: number;
    SessionDurationInSeconds: number;
    MessageTimeStamp: string;
    SessionId: string;
    CorrelationID: string;
}

export interface IGamblingSessionActionData {
    messageType: GamblingSessionActionType;
    sessionTotalWins: number;
    sessionTotalBets: number;
    sessionDurationInSeconds: number;
    messageTimeStamp: string;
    gamblingSessionId: string;
    correlationID: string;
}

export interface IGamblingSessionActionMessage extends IReceivedMessage<IGamblingSessionActionEvent> {

}

